// All site content for CF Action Design

export const LOGO = "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/186bn2nu_CF%20Black%20v2.webp";

export const CONTACT = {
  name: "MR. KABIR",
  phone: "+91 94497 44231",
  phoneHref: "tel:+919449744231",
  imdb: "https://www.imdb.com/name/nm8160384/",
  instagram: [
    { handle: "@chethandsouza", url: "https://instagram.com/chethandsouza" },
    { handle: "@cfactiondesign", url: "https://instagram.com/cfactiondesign" },
  ],
  training: "Chaosfaktory.com",
};

// Hero showreel — embedded background video (autoplay/muted/loop)
export const SHOWREEL = {
  // Primary cinematic hero loops (reliable autoplay HTML5 video)
  videoSources: [
    "/hero-jailer2.mp4?v=2",
  ],
  poster: "/hero-poster.jpg",
  tagline: "Stunt Direction · Fight Choreography · 2nd Unit Direction",
  // Actual studio showreel (YouTube — plays directly on click)
  youtubeId: "ytv-R3hNP3c",
  thumbnail: "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/ybna2m49_ca7942e7-5092-4add-b4b6-e6d10b0a2dd4.png",
};

export const NAV = [
  { label: "Showreel", id: "showreel" },
  { label: "Projects", id: "projects" },
  { label: "Portfolio", id: "studio" },
  { label: "Previz", id: "previs" },
  { label: "Equipment", id: "equipment" },
  { label: "Workshops", id: "workshops" },
  { label: "Contact", id: "contact" },
];

export const SELECTED_WORK = [
  "Aavesham", "Bagheera", "Max", "Kingdom", "UI", "Bhairathi Ranagal", "Sardar 2", "45",
];

export const CURRENT_PROJECTS = [
  { title: "JAILER 2", year: "Tamil · Single Card Action", img: "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/ta72wlhj_Jailer.jpg" },
  { title: "DRAGON", year: "Telugu · Action Director", img: "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/urs4ox9d_Dragon.jpg" },
  { title: "SCENE", year: "Tamil · Single Card Action", img: "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/bfwr7u55_scene-poster-web.jpg" },
  { title: "FAUZI", year: "Telugu · 2nd Unit Action Director", img: "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/3ugkzuhy_fauzi-poster-web.jpg" },
];

export const INTL_EXPERIENCE = [
  { place: "Sri Lanka", project: "Kingdom", detail: "City sequences" },
  { place: "Jordan", project: "Dragon", detail: "Dunes & deserts" },
  { place: "Dubai", project: "Khalifa", detail: "City chase & dune chasing" },
  { place: "Bangkok", project: "The Furious", detail: "Onset trainee" },
];

export const COLLABORATORS = [
  { name: "Kenji Tanigaki", note: "Director / Stunt Director — ‘The Furious’" },
  { name: "Tolga Değirmen", note: "Fight Designer — ‘The Witcher’" },
  { name: "Jason Oettlé", note: "Stunt Rigger — ‘The Batman’" },
];

export const BIO = `Chethan D'Souza is an Indian Stunt Director, Action Designer, Fight Choreographer, and Actor with over 22 years of professional experience in martial arts, weapon systems, and movement-based art forms. His journey in combat training began during his school years, laying the foundation for a career dedicated to cinematic action. His work spans feature films, commercials, games, and animation, across six language film industries.`;

export const BIO_LONG = `He is the Founder and Lead Action Designer of CF Action Design, a full-service professional stunt team comprising trained fighters, stunt performers, rigging specialists, and technical safety crew — operating with a dedicated stunt-visualization studio and a fully equipped rigging & safety truck. A certified All India Stunt Union Master Card holder, Chethan is a multiple-time national and international karate medalist and holds black belts in two martial art disciplines. He is also Co-founder of Chaos Faktory, one of India's largest stunt training centers.`;

export const STATS = [
  { value: "22+", label: "Years Experience" },
  { value: "06", label: "Film Industries" },
  { value: "68+", label: "IMDb Stunt Credits" },
  { value: "02", label: "Black Belts" },
];

export const MARQUEE = [
  "Stunt Rigging", "Fight Previz", "Action Design", "Fight Choreography",
  "Motion Capture", "Desert Dune Chases", "Vehicle Action", "Safety First",
];

// YouTube embeds (public, click-to-autoplay)
export const YOUTUBE = {
  fightPrevis: "RlcEHkZlwRI",
  animatics: "J-Us2C3aIy0",
  mocap: "GrqI5V_NbjE",
  mocapOutput: "J-S-8zn2HGo",
};

export const FIGHT_PREVIZ_THUMB = "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/p0aeii1r_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2001_47_58%20PM.png";

export const ANIMATICS_THUMB = "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/6nh8k0ee_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2002_12_28%20PM.png";

export const MOCAP_THUMB = "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/31ou1spj_mocap_shoot_1280w%20%281%29.jpg";

export const MOCAP_OUTPUT_THUMB = "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/kthzxeu2_mocap_output_1280w%20%281%29.jpg";

export const PREVIS_INTRO = `Once we understand the story, script, characters, emotional beats, and the placement of the fight within the film, we begin designing the action sequence in detail. The first step is creating a reference cut — a seamless compilation of relatable shots that establishes the intended tone, style, rhythm, camera language, and impact of the sequence.`;

export const PREVIS_LEAD = `From reference cut to rehearsal, camera exploration, edit and director review — every beat is designed around story, character and emotional intent.`;

export const PREVIS_PROCESS = [
  { n: "01", title: "Understand", body: "Story, script, character, emotion and the dramatic purpose of the sequence." },
  { n: "02", title: "Visualise", body: "Reference cuts establish tone, rhythm, camera language and intended impact." },
  { n: "03", title: "Build", body: "Choreography is tested with props, mats, harnesses, rigging and trained performers." },
  { n: "04", title: "Refine", body: "In-house camera and edit allow immediate review, iteration and director approval." },
];

export const PREVIS_BODY = `At CF Action Design / Chaos Faktory, we build the choreography around the character's emotion, motivation, and the director's vision. The complete fight previz is shot inside our fully equipped stunt training facilities using props, rigging systems, mats, harnesses, safety equipment, trained performers, and controlled setups — allowing us to test the action, refine choreography, and identify the strongest version of the sequence before reaching the actual location.`;

export const PREVIS_VALUE = `A well-executed fight previz can reduce action-sequence production costs by approximately 15–20%. Because we execute the previz at CF Action Design instead of on the main set, the previz execution cost itself is reduced by nearly 60%. With our in-house cameraman and editor, we shoot, cut, review, and refine immediately — making the process faster and production-ready.`;

export const ANIMATICS_BODY = `For large-scale, VFX-heavy sequences — vehicle chases, building collapses, explosions, helicopter action, animal sequences, and CGI-driven set pieces — we create detailed 3D animatics. Using 3D animation, motion capture, or AI-assisted visualization, we give the director, production, stunt, cinematography, and VFX teams a clear execution plan that prevents costly mistakes and aligns every department before going on set.`;

export const MOCAP_BODY = `CF Action Design creates action for games, cinematic cutscenes, animation and action-animation films. Our motion-capture work translates movement, combat mechanics, rhythm, impact and character intent into digital performance.`;

export const MOCAP_BODY_2 = `We have worked with Technicolor and Zebu and are closely associated with the ABAI Motion Capture Facility in Bengaluru and Annapurna Studios in Hyderabad, where Chethan works as an action consultant.`;

export const EQUIPMENT_COPY = `CF Action Design is supported by a fully equipped stunt rigging and safety truck — built to carry the essential systems, protection, and technical equipment required for controlled action execution across changing production environments. All equipment is certified to international safety standards. Backing this is a dedicated stunt rigging team with hands-on experience delivering major rigging setups, ensuring every sequence is executed with precision and safety at scale. A dedicated safety team further ensures the wellbeing of artists, stunt performers, and the overall set throughout every action sequence.`;

export const EQUIPMENT_TRUCK_IMG = "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/sm0mvhmx_cf_action_truck_vehicle_number_blurred.jpg";
export const EQUIPMENT_INVENTORY = "https://docs.google.com/presentation/d/1o2g-E9a6NyUTyX7IWnG1T3ZJoHhYvNPUUA6o0lGJrOA/edit";

export const WORKSHOP_COPY = `Professional stunt, fight and movement workshops at the CF / Chaos Faktory facility.`;
export const CHAOS_FAKTORY_URL = "https://chaosfaktory.com";

export const EQUIPMENT_INTRO = `A fully equipped rigging and safety truck — enabling efficient, safe execution of action sequences across varied terrains and production scales.`;

export const EQUIPMENT_ITEMS = [
  "Descender & Winch Systems", "Ratchet Rigs", "Air Rams & Kickers",
  "Crash Mats & Pads", "Harnesses & Fall Arrest", "Wire Fly Systems",
  "Fire & SFX Safety Gear", "Fight Weapon Systems",
];

export const PORTRAIT = "https://customer-assets-wrfwihn1.emergentagent.net/job_cinematic-stunts/artifacts/pp697czw_chethan%20-jordan.webp";
